import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 text-foreground-700">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-3xl font-semibold text-foreground-950">QOQO</span>
              <span className="block text-[10px] uppercase tracking-widest text-foreground-600 font-label mt-0.5">
                Cosmetics
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Die ehrliche, mehrfach zertifizierte Pflegeserie aus Deutschland. Luxuspflege in ihrer reinsten Form.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-label text-sm font-semibold uppercase tracking-wider text-foreground-950 mb-4">
              Produkte
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: '/produkte/skin-care', label: 'Skin Care', comingSoon: false },
                { to: '/produkte/reinigung', label: 'Reinigungsprodukte', comingSoon: true },
                { to: '/produkte/men-care', label: 'Men Care', comingSoon: true },
                { to: '/produkte/anti-aging', label: 'Anti Aging', comingSoon: true },
              ].map((item) => (
                <li key={item.to}>
                  {item.comingSoon ? (
                    <span className="inline-flex items-center gap-2 text-sm text-foreground-400 cursor-default">
                      {item.label}
                      <span className="px-2 py-0.5 rounded-full bg-background-200 text-[10px] font-label uppercase tracking-wide text-foreground-500 whitespace-nowrap">
                        Coming soon
                      </span>
                    </span>
                  ) : (
                    <Link to={item.to} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-label text-sm font-semibold uppercase tracking-wider text-foreground-950 mb-4">
              Unternehmen
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: '/ueber-uns', label: 'Über uns' },
                { to: '/qualitaet', label: 'Qualität' },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-label text-sm font-semibold uppercase tracking-wider text-foreground-950 mb-4">
              Rechtliches
            </h4>
            <div className="space-y-3">
              {/* Prominenter Widerrufsbutton */}
              <Link
                to="/widerruf"
                className="inline-flex items-center gap-2 px-3.5 py-2 bg-accent-500 text-background-50 text-sm font-medium rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-go-back-line" />
                </span>
                Vertrag widerrufen
              </Link>
              <ul className="space-y-2.5">
                {[
                  { to: '/impressum', label: 'Impressum' },
                  { to: '/datenschutz', label: 'Datenschutz' },
                  { to: '/agb', label: 'AGB & Widerruf' },
                  { to: '/cookies', label: 'Cookies' },
                ].map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 handgepackt eGbR – Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-4">
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-map-pin-line text-sm" />
              </span>
              Made in Germany
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-shield-check-line text-sm" />
              </span>
              Halal-zertifiziert
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}